var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_334_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15667 4.00625C4.41917 5.625 6.75042 8.625 6.75042 8.625V12.375C6.75042 12.7188 7.03167 13 7.37542 13H8.62542C8.96917 13 9.25042 12.7188 9.25042 12.375V8.625C9.25042 8.625 11.5754 5.625 12.8379 4.00625C13.1567 3.59375 12.8629 3 12.3442 3H3.65042C3.13167 3 2.83792 3.59375 3.15667 4.00625Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_334_529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.89be0e33b5969e5b4d794cc8d82e7c15.svg";
export { ForwardRef as ReactComponent };